// extracted by mini-css-extract-plugin
export default {"sound-section__content":"soundSection_sound-section__content__iszZ0"};